import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../hoc/Loading/Loading";
import axios from "../../axios";
import {
  groupContentFields,
  groupPrivacyStatusDesc,
  profilePicValidityCheck,
} from "../../utils/constants";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../utils/url";
import moment from "moment";
import { Modal, ModalBody, Button } from "reactstrap";
import CreateStoryForm from "./Components/GroupStory.jsx";
import StoryItems from "../stories/StoryItems.jsx";
import avatarIcon from "../../assets/default-avatar.png";
import BottomScrollListener from "react-bottom-scroll-listener";

class SingleGroupStories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      privacy: null,
      description: "",
      members: [],
      storyType: null,
      showCreateStoryModal: this.props.showCreateStoryModal,
      topics: [],
      skipValue: 0,
      filters: [],
      limit: 5,
      stories: [],
    };
  }

  componentDidMount() {
    let { skipValue, limit } = this.state;
    let that = this;
    let organizationId = this.props.user.profile.organizationId._id;
    let limitValue = 5;
    axios
      .get(url.getStories, {
        params: {
          noLoader: true,
          organizationId,
          value: "groups",
          groupId: this.props.group._id,
          skipValue,
          limitValue,
        },
      })
      .then(async ({ data }) => {
        if (data && data.data) {
          // const activeStories = filter(data.data.storyList, (eachStory) => { return eachStory.isDeleted === false });
          // ClearFiltermode is for onload changes when a clear filter button is pressed or when All category is clicked or when all the filters are cleared CleaClearFiltermode is checked as 0 to replace the previous fetch results that was based on the filter and show maximum 10 stories as existing
          // When ClearFiltermode set as 1 the stories will be appended to the fetch results.
          this.setState((prevState) => ({
            stories: [...prevState.stories, ...data.data.storyList],
            topicAlert: false,
            skipValue: prevState.skipValue + limit,
            profile: this.props.user.profile,
            totalStories: data.data.storyTotal,
            originalStoryTotal: data.data.storyTotal,
            ClearFiltermode: 1,
          }));
          // await this.setState({isApiLoading:false})
        }
      });
    this.getTopics();
  }

  getStoryFeeds = () => {
    let { skipValue, limit } = this.state;
    let that = this;
    let organizationId = this.props.user.profile.organizationId._id;
    let limitValue = 5;
    axios
      .get(url.getStories, {
        params: {
          noLoader: true,
          organizationId,
          value: "groups",
          groupId: this.props.group._id,
          skipValue,
          limitValue,
        },
      })
      .then(async ({ data }) => {
        if (data && data.data) {
          // const activeStories = filter(data.data.storyList, (eachStory) => { return eachStory.isDeleted === false });
          // ClearFiltermode is for onload changes when a clear filter button is pressed or when All category is clicked or when all the filters are cleared CleaClearFiltermode is checked as 0 to replace the previous fetch results that was based on the filter and show maximum 10 stories as existing
          // When ClearFiltermode set as 1 the stories will be appended to the fetch results.
          this.setState((prevState) => ({
            stories: [...prevState.stories, ...data.data.storyList],
            topicAlert: false,
            skipValue: prevState.skipValue + limit,
            profile: this.props.user.profile,
            totalStories: data.data.storyTotal,
            originalStoryTotal: data.data.storyTotal,
            ClearFiltermode: 1,
          }));
          // await this.setState({isApiLoading:false})
        }
      });
  };

  createMarkup = (input) => {
    return { __html: `<div>${input}</div>` };
  };

  renderContent = () => {
    let { searchedPhrase, help, searchedTerm } = this.state;
    if (searchedTerm !== "") {
      return (
        <div dangerouslySetInnerHTML={this.createMarkup(searchedPhrase)} />
      );
    } else {
      return <div dangerouslySetInnerHTML={this.createMarkup(help)} />;
    }
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  getTopics = () => {
    if (!this.props.user) return;
    let orgId = this.props.user.profile.organizationId._id;
    axios.get(url.getTopics(orgId)).then(({ data }) => {
      // console.log("data---", data.data)
      let topics = data.data;
      this.setState({
        topics: [...topics],
      });
    });
  };

  toggleCreateStory = (e) => {
    // console.log(e)
    this.setState({ showCreateStoryModal: true, storyType: "Create Story" });
  };

  closeModal = () => {
    let { showCreateStoryModal } = this.state;
    this.setState({ showCreateStoryModal: false });
    this.props.closeModal(false);
  };

  publishNewStory = (story) => {
    let { stories } = this.state;
    let result = [story, ...stories];
    this.setState((prevState) => ({
      stories: result,
      setImagesPreview: [],
      totalStories: prevState.totalStories + 1,
      originalStoryTotal: prevState.originalStoryTotal + 1,
      showCreateStoryModal: false,
    }));
    this.props.closeModal(false);
  };

  removeStoryFeeds = (id, type) => {
    let { stories } = this.state;
    this.setState({ showRemoveFeedConfirmationModal: false });
    const filteredStories = stories.filter((e) => e._id !== id);

    axios.put(url.removeStoryFeeds(id)).then((resp) => {
      if (resp.data.data.parentStory && resp.data.data.parentStory.item) {
        this.showStoryComments(resp.data.data.parentStory.item);
      }
      this.setState((prevState) => ({
        dropdownOpen: false,
        stories: [...filteredStories],
        totalStories: prevState.totalStories - 1,
        originalStoryTotal: prevState.originalStoryTotal - 1,
      }));
    });
  };

  // closeModal=()=>{
  //   this.setState({showCreateStoryModal:false})
  // }
  editParticularStoryobj = (story) => {
    console.log("CALL");
    const { stories } = this.state;
    const storyIndex = stories.findIndex((x) => x._id === story._id);
    let storiesArray = [...stories];

    if (storyIndex >= 0) {
      if (story.isFlagged && story.isFlagged.status === true) {
        storiesArray.splice(storyIndex, 1);
        this.setState({ stories: [...storiesArray] });
      } else {
        storiesArray[storyIndex] = { ...storiesArray[storyIndex], ...story };
        this.setState({ stories: [...storiesArray] });
      }
    }
  };

  handleOnDocumentBottom = () => {
    let { totalStories, skipValue } = this.state;
    if (skipValue < totalStories && totalStories > 5) {
      this.getStoryFeeds();
    }
  };

  render() {
    let {
      name,
      privacy,
      stories,
      description,
      filters,
      topics,
      storyType,
    } = this.state;

    let { currentRole } = this.props;

    let privacy_status = null;
    if (privacy) {
      privacy_status =
        privacy == "ENTERPRISE"
          ? "Open"
          : privacy == "PRIVATE"
          ? "Private"
          : privacy;
    }

    let profilePic =
      this.props.user.profile && this.props.user.profile.profilePic
        ? this.props.user.profile.profilePic
        : false;
    let user_name = `${this.props.user.profile.firstName} ${this.props.user.profile.lastName}`;

    return (
      <BottomScrollListener offset={100} onBottom={this.handleOnDocumentBottom}>
        {(scrollRef) => (
          <div ref={scrollRef} className="group_stories_container">
            {stories.map((item, idx) => {
              const actionType =
                item.isDeleted || item.isArchived ? "Restore" : "Archive";
              let avatar = item.isAnonymous
                ? avatarIcon
                : profilePicValidityCheck(item.profilePic) || avatarIcon;

              return (
                <StoryItems
                  showCreateStory={() => this.editStory(item)}
                  currentRole={currentRole}
                  group={this.props.group}
                  removeStoryFeeds={this.removeStoryFeeds}
                  deArchiveStory={this.deArchiveStory}
                  archiveStory={this.archiveStory}
                  filters={topics}
                  getStoryFeeds={this.getStoryFeeds}
                  showStoryRemoveConfirmation={this.showStoryRemoveConfirmation}
                  key={item._id + idx}
                  item={item}
                  actionType={actionType}
                  avatar={avatar}
                  description={description}
                  openMobilePopupFromGroups={true}
                  editParticularStoryobj={this.editParticularStoryobj}
                />
              );
            })}

            <CreateStoryForm
              group={this.props.group}
              topics={topics}
              onStoryPublish={this.publishNewStory}
              onStoryCancel={this.closeModal}
              storyType={storyType}
              showCreateStoryModal={
                currentRole == -1 ? false : this.props.showCreateStoryModal
              }
              currentGroupJoinedAnounymously={
                this.props.currentGroupJoinedAnounymously
              }
            />
          </div>
        )}
      </BottomScrollListener>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(SingleGroupStories, axios)));
